import React, { useEffect } from 'react';
import './modal.css';

const Modal = ({ isOpen, onClose, children }) => {
    useEffect(() => {
      // Prevent scrolling on the body when modal is open
      if (isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
  
      // Add ESC key listener to close modal
      const handleEscKey = (event) => {
        if (event.key === 'Escape') {
          onClose();
        }
      };
  
      if (isOpen) {
        document.addEventListener('keydown', handleEscKey);
      }
  
      // Cleanup function to reset overflow and remove event listener when component unmounts
      return () => {
        document.body.style.overflow = 'auto';
        document.removeEventListener('keydown', handleEscKey);
      };
    }, [isOpen, onClose]);
  
    // If modal is not open, don't render anything
    if (!isOpen) return null;
  
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="modal-close-btn" onClick={onClose}>×</button>
          {children}
        </div>
      </div>
    );
  };
  
  export default Modal;